import Icon from '@ant-design/icons';

const ExpandDownSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer" clipPath="url(#clip0_9077_8913)">
        <path
          id="Vector"
          d="M10.9118 6.12319L7.99512 7.98865L5.07845 6.12212C4.98034 6.05928 4.86203 6.01991 4.73716 6.00855C4.61229 5.99718 4.48594 6.01428 4.3727 6.05788C4.25945 6.10147 4.16391 6.16978 4.09711 6.25494C4.0303 6.34009 3.99494 6.43862 3.99512 6.53915L3.99512 7.67233C3.99518 7.75221 4.01768 7.83107 4.06095 7.90307C4.10422 7.97507 4.16716 8.03837 4.24512 8.0883L7.57845 10.2215C7.69669 10.2972 7.84365 10.3385 7.99512 10.3385C8.14659 10.3385 8.29354 10.2972 8.41178 10.2215L11.7451 8.0883C11.8231 8.03837 11.886 7.97507 11.9293 7.90307C11.9726 7.83107 11.9951 7.75221 11.9951 7.67233V6.53915C11.995 6.43871 11.9595 6.34033 11.8926 6.25533C11.8257 6.17033 11.7301 6.10218 11.6169 6.05871C11.5037 6.01525 11.3775 5.99824 11.2527 6.00964C11.128 6.02105 11.0098 6.06041 10.9118 6.12319Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9077_8913">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExpandDown = (props: any) => <Icon component={ExpandDownSvg} {...props} />;
export const ExpandDownIcon = ExpandDown;
